export const quoteThemeCssVars = {
  primary: "var(--quote-color-primary)",
  secondary: "var(--quote-color-secondary)",
  primary10: "var(--quote-color-primary-10)",
  primary20: "var(--quote-color-primary-20)",
  primaryDark: "color-mix(in srgb, var(--quote-color-primary) 75%, black)",
  onPrimary: "var(--quote-color-on-primary)",
  blockHeading: "var(--quote-color-block-heading)",
  headingFont: "var(--quote-font-heading)",
  bodyFont: "var(--quote-font-body)",
  radiusCard: "var(--quote-radius-card)",
  radiusPill: "var(--quote-radius-pill)",
  shadowCard: "var(--quote-shadow-card)",
  sectionGap: "var(--quote-section-gap)",
} as const;

export const quoteThemeColorStyles = {
  primary: { color: quoteThemeCssVars.primary },
  primaryBg: { backgroundColor: quoteThemeCssVars.primary },
  primary10Bg: { backgroundColor: quoteThemeCssVars.primary10 },
  secondaryBg: { backgroundColor: quoteThemeCssVars.secondary },
  secondaryBorder: { borderColor: quoteThemeCssVars.secondary },
  onPrimary: { color: quoteThemeCssVars.onPrimary },
  accentBadge: {
    backgroundColor: quoteThemeCssVars.primary10,
    color: quoteThemeCssVars.primary,
  },
  dualToneAccentBadge: {
    backgroundColor: quoteThemeCssVars.secondary,
    color: quoteThemeCssVars.primary,
  },
  dualToneBlockHeading: { color: quoteThemeCssVars.blockHeading },
  accentBorder: { borderColor: quoteThemeCssVars.primary },
  primaryButton: {
    backgroundColor: quoteThemeCssVars.primary,
    color: quoteThemeCssVars.onPrimary,
  },
  primaryGradientBar: {
    background: `linear-gradient(to bottom, ${quoteThemeCssVars.primary}, ${quoteThemeCssVars.primaryDark})`,
  },
  primaryGradientText: {
    background: `linear-gradient(to bottom, ${quoteThemeCssVars.primary}, ${quoteThemeCssVars.primaryDark})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  softGradientSurface: {
    background: `linear-gradient(to right, color-mix(in srgb, ${quoteThemeCssVars.primary} 12%, transparent), color-mix(in srgb, ${quoteThemeCssVars.primaryDark} 14%, transparent))`,
  },
  diagonalGradientSurface: {
    background: `linear-gradient(135deg, color-mix(in srgb, ${quoteThemeCssVars.primary} 8%, transparent), color-mix(in srgb, ${quoteThemeCssVars.primaryDark} 14%, transparent))`,
  },
} as const;
